"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PopoverPlacement", {
  enumerable: true,
  get: function get() {
    return _core.Placement;
  }
});
exports.Popover = void 0;

var React = _interopRequireWildcard(require("react"));

var _core = require("@popperjs/core");

var _PopoverContainer = require("./PopoverContainer");

var _hooks = require("../hooks");

var _core2 = require("@emotion/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// The current behaviour of Popover is that the PopoverContainer is not rendered if
// not open. This is somwhat problematic with refs + usePopper as it cannot recompute fast
// enough the new position, which leads to the popover container jump locations.
// To preserve the old behaviour, we need to put the usePopper in a seperate component
// to trigger a full re-render, which in turns means the ref will be created in time.
// This functionality should be removed in the future, since it's not good for a11y reasons.

/**
 * A small extension of an action taken, containing information, or more actions still.
 */
const Popover = ({
  className,
  isOpen = false,
  target,
  placement,
  noArrow,
  positionFixed = false,
  onOpen = () => {},
  onClose = () => {},
  autoClose = true,
  isFlipEnabled = true,
  light,
  zIndex,
  children
}) => {
  const _React$useState = React.useState(null),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        targetRef = _React$useState2[0],
        setTargetRef = _React$useState2[1];

  const _React$useState3 = React.useState(null),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        popperRef = _React$useState4[0],
        setPopperRef = _React$useState4[1];

  const clickOutsideRef = React.useRef();
  clickOutsideRef.current = popperRef;
  const isFirstPass = React.useRef(true);

  const _useToggle = (0, _hooks.useToggle)(isOpen),
        isActive = _useToggle.isActive,
        setInactive = _useToggle.setInactive,
        setActive = _useToggle.setActive;

  const _usePopper = (0, _hooks.usePopper)(targetRef, popperRef, {
    placement: placement || 'bottom-start',
    strategy: positionFixed ? 'fixed' : 'absolute',
    modifiers: [{
      name: 'flip',
      enabled: isFlipEnabled
    }]
  }),
        styles = _usePopper.styles,
        attributes = _usePopper.attributes,
        update = _usePopper.update;

  (0, _hooks.useOnClickOutside)(clickOutsideRef, () => {
    isActive && autoClose && onClose();
    isActive && update && update();
  });
  (0, _hooks.useEventListener)('keyup', event => {
    if (event.key === 'Escape') {
      onClose();
    }
  });

  function handleTriggerClick(event) {
    event.preventDefault();

    if (!isActive) {
      onOpen();
    } else {
      onClose();
    }
  }

  React.useEffect(() => {
    if (!isFirstPass.current) {
      if (isOpen) {
        setActive();
      } else {
        setInactive();
      }
    } else {
      isFirstPass.current = false;
    }
  }, [isOpen, setActive, setInactive]);
  const targetProps = {
    ref: setTargetRef
  };
  const targetEvents = {
    onClick: handleTriggerClick
  };
  return (0, _core2.jsx)(React.Fragment, null, target({
    targetProps,
    targetEvents,
    active: isOpen
  }), isActive && (0, _core2.jsx)(_PopoverContainer.PopoverContainer, {
    light: light,
    ref: setPopperRef,
    className: className,
    zIndex: zIndex,
    isActive: isActive,
    style: styles.popper,
    "data-placement": attributes && attributes.popper && attributes.popper['data-popper-placement']
  }, children, !noArrow && (0, _core2.jsx)(_PopoverContainer.PopoverArrow, null)));
}; // TODO: This needs to be removed since it potentially breaks


exports.Popover = Popover;